import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./auth/auth.slice";
import userSlice from "./user/user.slice";
import petSlice from "./pets/pet.slice";
import careTeamSlice from "./care-team/care-team.slice";
import kitSlice from "./kit/kit.slice";
import testsSlice from "./lab-tests/tests.slice";

export const rootReducer = combineReducers({
  authReducer: authSlice,
  userReducer: userSlice,
  petReducer: petSlice,
  teamReducer: careTeamSlice,
  testReducer: testsSlice,
  kitReducer: kitSlice,
});
